import nprogress from 'nprogress';
import { defineAppPlugin } from '/app/utils/app';

nprogress.configure({
    showSpinner: false,
});

export default defineAppPlugin(({ router }) => {
    router.beforeEach((to, from) => {
        if (to.path !== from.path) {
            nprogress.start();
        }
    });

    router.afterEach(() => {
        nprogress.done();
    });
});
